import { GetChatCompletionQuery, OpenAiChatRequestDisplayModel, PortalAiChatRole, PreCrawlQuery } from "@/api/model-index";
import { OpenAiService } from "@/api/service-index";
import { Component, OnInit } from "@angular/core";
import { DialogService } from "@progress/kendo-angular-dialog";
import Typewriter from 'typewriter-effect/dist/core';
import { UrlDialogComponent, UrlDialogResult } from "../../dialog/url-dialog.component";
import { Constants } from "@/constants";
import { I18nService } from "@/core/services/i18nService";
import { ConfirmationDialogAction, ConfirmationDialogComponent, ConfirmationDialogResult } from "@/core/components/dialogs/confirmation-dialog/confirmation-dialog.component";
import { Router } from "@angular/router";
import { LoadingAnimationService } from '../../../../services/loading-animation.service';


@Component({
    selector: 'ai',
    templateUrl: './ai.component.html',
    styleUrls: ['./ai.component.scss']
})
export class AIComponent implements OnInit {
    message: string = '';
    sending: boolean = false;
    messages: OpenAiChatRequestDisplayModel[] = [];
    url: string = '';
    
    constructor(protected openAiService: OpenAiService, protected dialogService: DialogService, protected languageService: I18nService, protected router: Router, protected loadingAnimationService: LoadingAnimationService) {
        if (localStorage.getItem('chatMessages')) {
            this.messages = JSON.parse(localStorage.getItem('chatMessages')!).slice(-10);
        }
        if (localStorage.getItem('chatUrl')) {
            this.url = localStorage.getItem('chatUrl')!;
        }
    }

    ngOnInit(): void {
        if (!this.url) {
            this.openUrlDialog();
        }
        document.getElementById('chat')?.scrollIntoView();
    }

    public deleteChat() {
        let dialog = this.dialogService.open({
            content: ConfirmationDialogComponent,
            maxWidth: Constants.DIALOG.MAX_WIDTH,
            maxHeight: Constants.DIALOG.MAX_HEIGHT,
            width: Constants.DIALOG.WIDTH,
            title: this.languageService.instant("dialogue.title.chat.delete")
        });

        dialog.content.instance.content = this.languageService.instant("dialogue.message.chat.delete");

        dialog.result.subscribe(result => this.onDeleteChatConfirmation(<ConfirmationDialogResult>result));
    }

    protected onDeleteChatConfirmation(result: ConfirmationDialogResult) {
        if (result.action == ConfirmationDialogAction.Confirm) {
            localStorage.removeItem('chatUrl');
            localStorage.removeItem('chatMessages');
            this.messages = [];
            this.url = '';
            this.openUrlDialog();
        }
    }

    protected openUrlDialog() {
        let dialog = this.dialogService.open({
          content: UrlDialogComponent,
          maxWidth: Constants.DIALOG.MAX_WIDTH,
          maxHeight: Constants.DIALOG.MAX_HEIGHT,
          minWidth: "30%",
          minHeight: "30%",
          title: this.languageService.instant("dialogue.title.url")
        });
    
        dialog.result.subscribe(result => this.onUrlDialogClose(<UrlDialogResult>result));
      }
    
      protected onUrlDialogClose(result: UrlDialogResult) {
        if (result.action == ConfirmationDialogAction.Confirm) {
            localStorage.setItem("chatUrl", result.url);
            this.url = result.url;

            let x = new PreCrawlQuery();
            x.url = result.url;

            const subcription = this.openAiService.apiOpenAiPreCrawlPost(x.AsRequestBody()).subscribe();

            this.loadingAnimationService.showSpinnerUsingSubscription(subcription);
        }
        else {
            this.router.navigate(['/']);
        }
      }

    async sendMessage(): Promise<void> {
        if (!this.message) {
            return;
        }

        this.sending = true;

        let msg = new OpenAiChatRequestDisplayModel();

        msg.role = PortalAiChatRole.User;
        msg.content = this.message;

        this.messages.push(msg);

        this.message = '';

        let x = new GetChatCompletionQuery();

        x.chatMessageList = this.messages;
        x.url = this.url;

        const typing = new OpenAiChatRequestDisplayModel();
        typing.isTyping = true;
        typing.role = PortalAiChatRole.Assistant;
        this.messages = Object.assign([], this.messages);
        this.messages.push(typing);

        let result = await this.openAiService.apiOpenAiGetChatCompletionPost(x.AsRequestBody()).toPromise()

        this.messages.splice(this.messages.length - 1, 1);

        this.sending = false;

        let copyOfContent = result.content;
        
        // make result.content empty to show typewriter effect
        result.content = '';
        this.messages.push(result);

        // set copyOfContent again to result.content
        result.content = copyOfContent;

        localStorage.setItem('chatMessages', JSON.stringify(this.messages));

        setTimeout(() => {
            // get last message that was pushed into this.messages und füge den typewriter effect hinzu
            let lastMessage = this.messages[this.messages.length - 1];

            // get index of last message that was pushed into this.messages
            let index = this.messages.length - 1;

            // get html element with index
            let element = document.getElementById(index.toString());

            // animate typing effect
            var typewriter = new Typewriter(element, {
                delay: 15,
                autoStart: true,
                loop: false,
                cursor: '',
            });

            // remove Typewriter__cursor div
            let cursor = document.getElementsByClassName('Typewriter__cursor');
            cursor[0].remove();

            console.log(element);
            console.log(lastMessage);

            typewriter
                .typeString(copyOfContent)
                .start();

            document.getElementById('chat')?.scrollIntoView();
        }, 1);
    }
}
